import { Coupon, Product } from '../types/Add-subscription.types';
import exactMath from 'exact-math';

interface Category {
  title: string;
  type: string[];
}

interface usePurchaseSummaryReturn {
  discount: number;
  categories: Category[];
}

interface usePurchaseSummaryProps {
  products: Product[];
  counts: Record<string, number>;
  appliedCoupon: Coupon | null;
}

const categories: Category[] = [
  { title: 'Carretera', type: ['Vehiculos', 'Motocicleta'] },
  { title: 'Hogar', type: ['Hogar'] },
  { title: 'Addons', type: ['Add-on'] },
];

export const usePurchaseSummary = ({
  appliedCoupon,
  counts,
  products,
}: usePurchaseSummaryProps): usePurchaseSummaryReturn => {
  const discount = appliedCoupon
    ? (() => {
        const product = products.find((p) =>
          p.prices.some((price) => price.id === appliedCoupon.price.id)
        );

        if (!product) return 0;

        const priceObj = product.prices.find(
          (p) => p.id === appliedCoupon.price.id
        );
        if (!priceObj) return 0;

        const count = counts[appliedCoupon.price.id] || 0;
        const priceToUse =
          count >= priceObj.max_additional
            ? priceObj.additional_price
            : priceObj.price;

        const calculatedDiscount = appliedCoupon.is_percent
          ? exactMath.mul(count, priceToUse, appliedCoupon.amount / 100)
          : appliedCoupon.amount;

        // Ensure the discount is returned with two decimal places without rounding
        return Math.floor(calculatedDiscount * 100) / 100;
      })()
    : 0;

  return {
    discount,
    categories,
  };
};
